/**
 * useAuth Hook
 *
 * Custom hook to access authentication context.
 * Provides easy access to auth state and methods.
 *
 * @module hooks/useAuth
 */

import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Use authentication hook
 *
 * @returns {Object} Auth context value
 * @throws {Error} If used outside AuthProvider
 */
const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};

export default useAuth;
